/**
 * How a reservation is drawn on the schedule views.
 *
 * Direct Control windows (kind 'direct_control') are shaded in the blue the operations page uses
 * for an interactive session (CurrentObservationCard's "Interactive Session" pane,
 * rgba(33,150,243,…) = MUI blue 500), solid rather than hatched, so a booked real-time window
 * reads as "someone will be driving the telescope" rather than as admin-blocked time. The fill is
 * stronger than that pane's 0.06 because a timeline band is a thin bar, not a whole card.
 *
 * Every other reservation keeps the view's own orange hatch; callers spread these over it.
 */
export const DIRECT_CONTROL_RGB = '33, 150, 243';
const blue = (a) => `rgba(${DIRECT_CONTROL_RGB}, ${a})`;

export const isDirectControl = (r) => r?.kind === 'direct_control';

/** MUI `sx` overrides for a Direct Control band (Box-based timelines). */
export const DIRECT_CONTROL_BAND_SX = {
  backgroundColor: blue(0.25),
  backgroundImage: 'none',
  border: `1px solid ${blue(0.6)}`,
};
export const DIRECT_CONTROL_HOVER_SX = { borderColor: blue(0.9) };
export const DIRECT_CONTROL_FOCUS_SX = { outline: `2px solid ${blue(0.9)}`, outlineOffset: 1 };

/** Inline `style` overrides for a Direct Control band (div-based timelines). */
export const DIRECT_CONTROL_BAND_STYLE = {
  backgroundColor: blue(0.25),
  backgroundImage: 'none',
  borderLeft: `2px solid ${blue(0.8)}`,
  borderRight: `2px solid ${blue(0.8)}`,
};

/** Badge for a reservation row in tabular schedules. */
export const reservationBadge = (r) => (isDirectControl(r)
  ? { label: 'Direct Control', style: { backgroundColor: blue(0.2), color: '#0d47a1', fontWeight: 700 } }
  : { label: 'Reserved', style: { backgroundColor: 'rgba(255,152,0,0.2)', color: '#b26a00', fontWeight: 700 } });

/** Tooltip/label prefix. */
export const reservationLabel = (r) => (isDirectControl(r) ? 'Direct Control' : 'Reserved');
